import React, { Component } from "react";
import Button from "react-bootstrap/lib/Button";
import EventEmitter from "../../services/event-emitter";
import { logError } from "../../services/utils";
import { postRequest, putRequest } from "../../api/ApiService";
import HelpIconButtonWithTooltipAndTypeformModal from "../../components/typeform/HelpIconButtonWithTooltipAndTypeformModal";
import { incrementUnacceptedDecisions } from "../../api/SubmitDecisions";
import MgBusinessCaseContent from "../../components/typeform/MgBusinessCaseContent";
import Fragment from "react-dot-fragment";

export default class ModalPMDecisionsPlacement extends Component {
  constructor(props) {
    super(props);

    this.state = {
      products: props.products,
      isSaving: false
    };

    this.eventemitter = EventEmitter.getInstance();
  }

  showPopup = () => {
    this.eventemitter.trigger("coaching-feedback", [
      'Food for Thought',
      <Fragment>
        <b>Very interesting!</b><br />
        You chose to sell through an online distributor instead of direct
        selling for one or more of your products.
      </Fragment>,
      <Fragment>
        Please double check <a href="/analysis/bcase/market" target="_blank">The Market</a> section
        of the business case just to make sure you fully understand the impact of this decision.
      </Fragment>
    ]);
  };

  openModal = () => {
    if (this.props.tourMode === true) {
      this.showModalTour();
      return;
    }

    this.showModal();
  };

  componentDidMount() {
    this.eventemitter.on("product-marketing-show-modal3", this.showModal);
    this.eventemitter.on("product-marketing-hide-modal3", this.hideModal);
    this.eventemitter.on("product-marketing-force-update3", this.rerender);
    this.eventemitter.on("pm-decisions-open-modal3", this.openModal);
  }

  componentWillUnmount() {
    this.eventemitter.off("product-marketing-show-modal3", this.showModal);
    this.eventemitter.off("product-marketing-hide-modal3", this.hideModal);
    this.eventemitter.off("product-marketing-force-update3", this.rerender);
    this.eventemitter.off("pm-decisions-open-modal3", this.openModal);
  }

  rerender = () => {
    this.forceUpdate();
  };

  showModalTour = () => {
    // do nothing
  };

  showModal = () => {
    if (this.props.tourMode === true) {
      window.$("#myModalDecisionsPlacement").data("bs.modal", null);
      window.$("#myModalDecisionsPlacement").modal({
        keyboard: false,
        backdrop: "static",
        show: true
      });
      return;
    }

    if (this.props.hasAccess === true) {
      window.$("#myModalDecisionsPlacement").data("bs.modal", null);
      window.$("#myModalDecisionsPlacement").modal("show");
    } else {
      this.props.showRoleAlert();
    }
  };

  hideModal = () => {
    window.$("#myModalDecisionsPlacement").modal("hide");
  };

  componentWillReceiveProps(nextProps) {
    if (this.state.products !== nextProps.products) {
      this.setState({
        products: nextProps.products
      });
    }
  }

  createSale(data) {
    return postRequest(`${process.env.REACT_APP_API_URL}team/sales/`).send(
      data
    );
  }

  updateSale = (data, sale_id) => {
    return putRequest(
      `${process.env.REACT_APP_API_URL}team/sales/${sale_id}/`
    ).send(data);
  };

  updateClient = e => {
    let select = e.target;
    let products = this.state.products;
    let id = parseInt(select.dataset.id, 10);
    let value = parseInt(select.value, 10);

    if (id in products) {
      products[id].client = value;

      this.setState({
        products
      });
    }
  };

  updateSales = () => {
    if (this.props.tourMode === true) {
      // do nothing
      return;
    }

    this.setState({
      isSaving: true
    });

    let requests = [];

    Object.keys(this.state.products).forEach(product_id => {
      product_id = parseInt(product_id, 10);

      let product = this.state.products[product_id];
      let client_id = product.client;
      if (client_id === 0) {
        client_id = this.props.sales_clients["Direct Sales"];
      }

      let data = {
        product: product_id,
        client: client_id
      };

      if (product.sale_id > 0) {
        requests.push(this.updateSale(data, product.sale_id));
      } else {
        requests.push(this.createSale(data));
      }
    });

    const joinRequest = Promise.all(requests);

    joinRequest
      .then(res => {
        const popupShown = res.filter(i => i.body.client === 4).length > 0;
        if (popupShown) {
          this.showPopup();
        }

        this.setState(
          {
            isSaving: false
          },
          () => {
            this.props.showSuccessMessage('New sales decision was successfully set for your product(s)');
            incrementUnacceptedDecisions("marketing");
            window.$("#myModalDecisionsPlacement").modal("hide");
            this.props.reloadData();
            this.props.getSubmissionData();
          }
        );
      })
      .catch(err => {
        logError(err, "ModalPMDecisionsPlacement", "updateSales");
      });
  };

  get isSaveDisabled() {
    if (this.props.tourMode === false) {
      return this.state.isSaving;
    }

    return true;
  }

  render() {
    const isSaving = this.state.isSaving;
    let modalClassName = "modal fade";
    if (this.props.tourMode === true) {
      modalClassName = "modal";
    }

    return (
      <div
        className={modalClassName}
        id="myModalDecisionsPlacement"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="myModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div
              id="product-marketing-placement-header"
              className="modal-header"
            >
              <div className="row">
                <div className="col-xs-7">
                  <h4
                    className="modal-title title-light-blue"
                    id="myModalLabel"
                  >
                    Sales Channel
                    <HelpIconButtonWithTooltipAndTypeformModal
                      iconSize="xs"
                      {...MgBusinessCaseContent.SALES_SPEND}
                    />
                  </h4>
                </div>
              </div>
            </div>
            <div className="modal-body">
              <div className="table-responsive mt-20">
                <table className="table">
                  <thead>
                    <tr className="border-none">
                      <th className="text-center">Product Name</th>
                      <th className="text-center">Sales Channel</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Object.keys(this.state.products).map(product_id => {
                      let product = this.state.products[product_id];

                      return (
                        <tr
                          className="text-center border-none"
                          key={product_id}
                        >
                          <th className="middle text-center">
                            Product {product.name}
                          </th>
                          <td className="text-center">
                            <select
                              data-id={product_id}
                              onChange={this.updateClient}
                              value={product.client}
                            >
                              <option
                                value={this.props.sales_clients["Direct Sales"]}
                              >
                                Direct Sales
                              </option>
                              <option
                                value={this.props.sales_clients["Distributors"]}
                              >
                                Distributors
                              </option>
                            </select>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="modal-footer text-center">
              <button
                type="button"
                className="btn btn-cancel"
                data-dismiss="modal"
                disabled={this.props.tourMode}
              >
                Cancel
              </button>
              <Button
                id="product-marketing-placement-save"
                className="btn btn-save"
                disabled={this.isSaveDisabled}
                onClick={!isSaving ? this.updateSales : null}
              >
                {isSaving ? "Saving..." : "Save"}
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/modal/ModalPMDecisionsPlacement.js